import Vue from 'vue'
import Router from 'vue-router'
import { getToken, removeToken } from '@/utils/auth.js'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import store from '@/store'
import { fetchUserInfo, fetchUserShopInfo } from '@/store/api.js'

import Layout from '@/views/layout/index.vue'
import Login from '@/views/login.vue'
import ShopInfo from '@/views/shop/info.vue'
import ShopGoodsList from '@/views/shop/goods-list.vue'
import ShopTags from '@/views/shop/tags.vue'
import shopGrouponList from '@/views/shop/groupon-list.vue'
import shopGrouponDetail from '@/views/shop/groupon-detail.vue'
import shopGoodsEdit from '@/views/shop/goods-edit.vue'
import ShopOrderList from '@/views/shop/order-list.vue'
import RobotManager from '@/views/robot/index.vue'
import GroupList from '@/views/group/group-list'
import GroupEdit from '@/views/group/group-edit'
import ViewList from '@/views/view/view-list'
import ViewEdit from '@/views/view/view-edit'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/dashboard'
    },
    {
      path: '/dashboard',
      component: Layout,
      children: [{
        path: '/shop/:sid/info/',
        component: ShopInfo
      }, {
        path: '/shop/:sid/goods/list',
        component: ShopGoodsList
      }, {
        path: '/shop/:sid/goods/add',
        component: shopGoodsEdit
      }, {
        path: '/shop/:sid/goods/edit',
        component: shopGoodsEdit
      }, {
        path: '/shop/:sid/tags',
        component: ShopTags
      }, {
        path: '/shop/:sid/group/list',
        component: shopGrouponList
      }, {
        path: '/shop/:sid/group/:gid',
        component: shopGrouponDetail
      }, {
        path: '/shop/:sid/orders/list',
        component: ShopOrderList
      }, {
        path: '/shop/:sid/robot',
        component: RobotManager
      }, {
        path: '/views',
        component: ViewList
      }, {
        path: '/view/create',
        component: ViewEdit
      }, {
        path: '/view/:viewId',
        component: ViewEdit
      }, {
        path: '/groups',
        component: GroupList
      }, {
        path: '/group/create',
        component: GroupEdit
      }, {
        path: '/group/:groupId',
        component: GroupEdit
      }]
    },
    {
      path: '/login',
      component: Login
    }
  ]
})

NProgress.configure({ showSpinner: false })

const whiteList = ['/login']
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    if (to.path === '/login') {
      NProgress.done()
      next({ path: '/' })
    } else {
      if (!store.state.userInfo) {
        Promise.all([fetchUserInfo(), fetchUserShopInfo()]).then(result => {
          result[0].is_merchant = result[1].is_merchant
          result[0].is_applied = result[1].is_applied
          store.commit('setUserInfo', result[0])
          result[1].shops && store.commit('setShopInfoAll', result[1].shops)
          result[1].merchant && store.commit('setMerchantInfo', result[1].merchant)
        }).then(() => {
          NProgress.done()
          next()
        }).catch(err => {
          console.error(err)
          NProgress.done()
          removeToken()
          next({ path: '/login' })
        })
      } else {
        NProgress.done()
        next()
      }
    }
  } else {
    // 未登录重定向
    if (~whiteList.indexOf(to.path)) {
      next()
    } else {
      next('/login')
    }
    NProgress.done()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js